export {
    CONSENT_MODAL_TEXT,
    ConsentModal,
    ConsentRevokeModal
} from './ConsentModal';
export type { TrackPropertyStatus } from './ConsentModal.types';
export type { GrantTrackedPropertyAlertConsentMutation } from './queries/grantTrackedPropertyAlertConsent.generated';
